import { combineReducers } from 'redux';

import { edit } from './edit';
import { communication } from './communication';
import * as TS from '../../types';

export const reducer = combineReducers<TS.ReduxState>({ edit, communication });
